﻿import * as $helpers from './_helpers'
import { getList, reloadList } from './blog.list'
import { loadBlogPostModal, saveHidden, saveInteresting } from './blog.shared'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    parentName: string
    parentPrefix: string
    sort: string
    sortAsc: boolean
}

var options: IInitOptions

export const init = ($options: IInitOptions): void => {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName))

    $('.' + options.pageName + ' .' + options.pagePrefix + '__ofinterest-icon').click(function () {
        const id: string = $(this).attr('data-id')
        saveInteresting(id, () => {
            reloadList()
        })
    })

    $('.' + options.pageName + ' .' + options.pagePrefix + '__read-icon').click(function () {
        const id: string = $(this).attr('data-id')
        saveHidden(id, () => {
            reloadList()
        })
    })

    $('.' + options.pageName + ' .' + options.pagePrefix + '__link').click(function () {
        const id: string = $(this).attr('data-id')
        loadBlogPostModal(id, () => {
            reloadList()
        })
    })

    $('.' + options.pageName + ' .bcfla-th-sortable').click(function () {
        const sort: string = $(this).attr('data-sort')
        let sortasc: boolean = options.sortAsc
        let sortascdefault: boolean = $(this).attr('data-sortasc') === 'true'
        let currsort: boolean = sort === options.sort

        if (currsort) {
            sortasc = !sortasc
            console.log('sort', 'flipping asc', sort, sortasc)
        } else {
            sortasc = sortascdefault
            console.log('sort', 'new sort', sort, sortasc)
        }

        getList(1, sort, sortasc)
    })
}

export const getPagedList = (page: number): void => {
    getList(page, options.sort, options.sortAsc)
}
